import { render, staticRenderFns } from "./ProductionTeamList.vue?vue&type=template&id=c4ea0df0&scoped=true&"
import script from "./ProductionTeamList.vue?vue&type=script&lang=js&"
export * from "./ProductionTeamList.vue?vue&type=script&lang=js&"
import style0 from "./ProductionTeamList.vue?vue&type=style&index=0&id=c4ea0df0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ea0df0",
  null
  
)

export default component.exports